import React from 'react';
import './App.css';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Home from './Components/Home/Home';
import Services from './Components/Services/Services';
import OurScience from './Components/OurScience/OurScience';
import AboutUs from './Components/AboutUs/AboutUs';
import Career from './Components/Career/Career';
import ContactUs from './Components/ContactUs/ContactUs';
import Errorpage from './Components/Errorpage/Errorpage';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Home/>}/>
        <Route path='/services' element={<Services/>}/>
        <Route path='/ourscience' element={<OurScience/>}/>
        <Route path='/aboutus' element={<AboutUs/>}/>
        <Route path='/career' element={<Career/>}/>
        <Route path='/contactus' element={<ContactUs/>}/>
        <Route path='/*' element={<Errorpage/>}/>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
